'use client'

import { useEffect } from 'react'

/** Keeps the app on brand dark theme; clears legacy theme preference from storage. */
export default function ThemeLock() {
  useEffect(() => {
    document.documentElement.dataset.theme = 'dark'
    try {
      localStorage.removeItem('theme')
    } catch {
      // private mode / blocked storage
    }
  }, [])

  return null
}
